var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNotFitIcon = function SvgNotFitIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154 80c0 40.869-33.131 74-74 74-40.87 0-74-33.131-74-74C6 39.13 39.13 6 80 6c40.869 0 74 33.13 74 74Z",
    fill: "#F7F9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m120 111 6 6-6 6",
    stroke: "#F1928D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83 117h41.5",
    stroke: "#F1928D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 117h45m-45 0 6-6m-6 6 6 6",
    stroke: "#F1928D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.414 74.011a1 1 0 0 0-.821 1.414l10.568 22.993a1 1 0 0 0 .908.582h65.093a.999.999 0 0 0 .846-.468l4.901-7.799L128 65.74l-27.174 2.377-67.411 5.895Z",
    fill: "#FBFCFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m100.826 68.116 25.409-2.222a1 1 0 0 1 .984 1.436l-6.528 13.309a1 1 0 0 1-.86.559L103 81.839l-16.454.628m14.28-14.351L33.415 74.01a1 1 0 0 0-.822 1.414l10.568 22.993a1 1 0 0 0 .908.582h65.093a.999.999 0 0 0 .846-.468l4.901-7.799m-14.083-22.617-7.112-9.803M44 60.25V49.625a1 1 0 0 1 1-1h28.143m0 0H86.34a1 1 0 0 1 .816.422l6.558 9.266m-20.571-9.688L68.82 37.634a1 1 0 0 0-.93-.634H55.856a1 1 0 0 0-1 1v4.813m38.857 15.5L71.273 60.25",
    stroke: "#A3ADC4",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 25,
    r: 6,
    fill: "#F5FAFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 4,
    r: 4,
    fill: "#F5FAFA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 27,
    r: 4,
    fill: "#F5FAFA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 133,
    r: 8,
    fill: "#F5FAFA"
  })));
};

export { SvgNotFitIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/not-fit-icon.346f200b.svg";